import { Dispatch, SetStateAction, useContext, useMemo } from 'react';
import { ActionType } from "./enum/action";
import { UserDataContext } from "../component/contents/Contents";
import { ValidateMessages } from '../component/validation/IValidation';
import valueFromValid from '../util/valueFromValid';

export type Actions = {
  [type in ActionType]: Function;
};

const useActions = (
  valid: ValidateMessages,
  setStep: (num: number) => void,
  index: number,
  setTouched: Dispatch<SetStateAction<boolean>>,
  ts: number,
  actionCollapse: () => void
) => {
  const userData = useContext(UserDataContext);

  const actions: Actions = useMemo(() => ({
    [ActionType.SAVE]: () => {
      // console.debug("useActions SAVE", valid, valueFromValid(valid, true))
      userData.input = { ...(userData.input || {}), ...valueFromValid(valid, true) };
    },
    [ActionType.NEXT]: () => {
      setStep(index + 1);
      setTouched(false);
    },
    [ActionType.ACTIVATE]: (i?: number) => {
      setStep(i || index);
      setTouched(true);
    },
    [ActionType.COLLAPSE]: () => { actionCollapse(); },
    [ActionType.FETCH]: (url: string, callback: Function, option: { [key: string]: any } = {}) => {
      const _option: {
        method: string,
        headers: { [key: string]: string },
        body?: string;
      } = {
        method: option?.method || "POST",
        headers: option?.headers || {
          "Content-Type": "application/json"
        },
        body: null
      };
      if (_option.method === "POST") {
        _option.body = JSON.stringify(userData);
      }
      
      fetch(url, _option)
        .then(res => res.json)
        .then(res => {
          // console.log(res);
          setStep(index + 1);
          callback({ step: index, ts, response: res, data: userData });
        })
        .catch(err => {
          // console.log(err);
          alert("エラーが発生しました\nもう一度やりなおしてください。");
          callback({ step: index, ts, error: err, data: userData });
          // dbg
          setStep(index + 1);
        });
    }
  }), [setStep, index, valid, userData]);

  return { actions };
}

export default useActions;